/**
 * People JavaScript
 *
 * Note that all the dom traversal isn't
 * very efficient, but it allows us to
 * only do the work once someone clicks a
 * toggle rather than on page load.
 */
// if we have people
const people = document.querySelector('.people');
if (people) {
	// when we click anywhere within people
	people.addEventListener('click', (e) => {
		// if this is a toggle button (may have been created dynamically after page load)
		if (e.target.classList.contains('people__toggle')) {
			// get the containing person
			const person = e.target.parentElement.parentElement.parentElement;
			// figure out if we're already active
			const isActive = person.classList.contains('show-contact');
			// if we're not active then see if we're the last in row (to extend leftward)
			if (!isActive) {
				const parent = person.parentElement;
				const parentRight = parent.offsetLeft + parent.clientWidth;
				const personRight = person.offsetLeft + person.clientWidth * 2;
				person.classList.toggle(
					'show-contact--reverse',
					parentRight < personRight
				);
			}
			// toggle active state
			person.classList.toggle('show-contact', !isActive);
		}
	});
}
